import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=0b642a58&scoped=true&"
import script from "./ChangePassword.vue?vue&type=script&lang=ts&"
export * from "./ChangePassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b642a58",
  null
  
)

export default component.exports